export const tasksGetters = {
    tasksData: (state) => state.tasksData,
    tasksList: (state)=>  {
      console.log("GETTER",state.tasksList)
      return state.tasksList
    },
    tasksDetails: (state)=> state.tasksDetails,
  }